import type { CrudConfig } from '@startupquickstart/frontend';

export interface Language {
  id: string;
  name: string;
  code: string;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

export const languageCrudConfig: CrudConfig<Language> = {
  entityName: 'Language',
  entityNamePlural: 'Languages',

  endpoints: {
    list: '/languages',
    single: (id) => `/languages/${id}`,
    create: '/languages',
    update: (id) => `/languages/${id}`,
    delete: (id) => `/languages/${id}`,
  },

  fields: [
    {
      key: 'name',
      label: 'Name',
      type: 'text',
      required: true,
      validation: { min: 2, max: 100 },
      helpText: 'Display name for the language (e.g., "English", "Spanish")',
    },
    {
      key: 'code',
      label: 'Code',
      type: 'text',
      required: true,
      validation: {
        pattern: /^[a-z]{2,3}$/,
        custom: (value: string) => {
          if (!/^[a-z]{2,3}$/.test(value)) {
            return 'Code must be a valid ISO 639-1 or 639-2 code (2-3 lowercase letters)';
          }
          return null;
        },
      },
      helpText: 'ISO 639-1 or 639-2 language code (e.g., "en", "es", "it")',
    },
    {
      key: 'isDefault',
      label: 'Default Language',
      type: 'boolean',
      required: false,
      helpText: 'Mark as default language for fallbacks',
    },
  ],

  listView: {
    fields: ['name', 'code', 'isDefault', 'createdAt'],
    searchableFields: ['name', 'code'],
    sortableFields: ['name', 'code', 'createdAt'],
    itemsPerPage: 10,
    actions: {
      create: {
        enabled: true,
        url: '/languages/new',
      },
      view: { enabled: true },
      edit: { enabled: true },
      delete: { enabled: true },
    },
  },

  detailView: {
    sections: [
      {
        title: 'Language Details',
        fields: ['name', 'code', 'isDefault', 'createdAt', 'updatedAt'],
        defaultExpanded: true,
      },
    ],
  },

  form: {
    sections: [
      {
        title: 'General',
        fields: ['name', 'code', 'isDefault'],
        columns: 1,
      },
    ],
  },
};
